/**
 * Micheals Infrastructure Advisory - STRATEGIC BUSINESS CONFIGURATION
 * ROLE: Central Truth for Firm Identity, Legal Standing, and National SEO.
 * VERSION: 4.1.0 (National Consultation Model - 2026)
 */

export const businessConfig = {
  // BRAND IDENTITY: National Consultation Authority
  name: "MED Consultation",
  legalName: "Micheals Electric And Design LLC",
  brandSpelling: "MED", 
  tagline: "Engineering the Atmosphere",
  motto: "Technical Oversight. Bespoke Infrastructure Design.",
  description: "High-fidelity technical architecture, forensic diagnostics, and principal oversight for premium estates and commercial developments nationwide.",
  
  // LEADERSHIP
  founder: "Mizrahyim D.",
  title: "Principal Design Consultant", 
  
  // CONTACT & REACH: National HQ with Regional Anchors
  phone: "(704) 491-4000",
  email: "info@medconsulting.solutions", 
  address: {
    display: "Charlotte, NC | National Advisory HQ",
    city: "Charlotte",
    state: "NC",
    zip: "28202", // Uptown Charlotte Core
    region: "Domestic US / North America",
    lat: 35.2271,
    lng: -80.8431
  },
  
  // RADIUS: Shifted to Service-Agnostic National Model
  operatingRadius: "National (Remote Advisory) | Selected On-Site Project Stewardship",
  hours: "Mon - Fri: 8:00 AM - 6:00 PM EST | Consultations by Appointment",

  // 2026 STRATEGIC PILLARS: High-margin consultation focus
  coreSpecialties: [
    "Infrastructure Resiliency Strategy", 
    "Advanced System Modernization", 
    "Luminous Environment Design", 
    "Principal Project Oversight",
    "Forensic Logic Diagnostics"
  ],

  // CONSULTATION PROTOCOL: Professional Fee Structure
  engagementTiers: {
    briefing: { label: "Initial Briefing", fee: 150, focus: "National Scope Alignment" },
    audit: { label: "Forensic Infrastructure Audit", fee: 450, focus: "System Logic & Vulnerability Review" },
    oversight: { label: "Project Stewardship", focus: "Construction Management & Quality Assurance" },
    retainer: { label: "Design Retainer", fee: 2500, focus: "Technical Specifications & Vendor Liaison" }
  },

  // LEGAL STANDING: Defining the Consultative Boundary
  legal: {
    disclaimer: "MED Consultation acts exclusively in a strategic advisory and design capacity. We provide technical oversight and specifications; physical implementation is performed by locally licensed contractors. No manual trade labor is provided.",
    ncStatute: "NCGS § 44A-8 (Professional Design Services)",
    status: "Independent Strategic Oversight Provider" 
  },

  partners: {
    technical: "Licensed Infrastructure Partners",
    fulfillment: "Authorized Local Implementation Teams",
  },

  // SEO CLASSIFICATION: Domestic Authority
  organization: "National Technical Operations",
  serviceArea: "United States (Nationwide)",
  
  // REGIONAL HUBS: Geographic reach from Atlantic to Pacific
  regions: [
    {
      id: "east-coast",
      label: "Atlantic / Eastern District",
      timeZone: "EST",
      hubs: [
        {
          name: "Charlotte & Carolinas (HQ)",
          state: "NC/SC",
          slug: "charlotte-hq",
          focus: "Architectural Integration & Capacity Strategy",
          neighborhoods: ["Myers Park", "Uptown", "The Peninsula", "Kingsley"]
        },
        {
          name: "Tri-State Metro",
          state: "NY/NJ",
          slug: "nyc-metro",
          focus: "High-Density Urban Infrastructure",
          neighborhoods: ["Manhattan", "Brooklyn Heights", "Jersey City"]
        }
      ]
    },
    {
      id: "central",
      label: "Midwest & Central District",
      timeZone: "CST",
      hubs: [
        {
          name: "Chicago",
          state: "IL",
          slug: "chicago-il",
          focus: "Industrial Automation & Grid Resilience",
          neighborhoods: ["Lincoln Park", "West Loop", "Gold Coast"]
        },
        {
          name: "Dallas / Fort Worth",
          state: "TX",
          slug: "dallas-tx",
          focus: "Estate-Scale Power Logic",
          neighborhoods: ["Highland Park", "Preston Hollow"]
        }
      ]
    },
    {
      id: "west-coast",
      label: "Pacific District",
      timeZone: "PST",
      hubs: [
        {
          name: "San Francisco / Silicon Valley",
          state: "CA",
          slug: "bay-area-ca",
          focus: "Smart Logic & Tech-Integrated Design",
          neighborhoods: ["Palo Alto", "Atherton", "Marina District"]
        }
      ]
    }
  ],

  socials: {
    instagram: "https://instagram.com/medconsulting",
    houzz: "https://houzz.com/pro/medconsulting",
    google: "https://g.page/med-consulting-group"
  }
};

export const BusinessInfo = businessConfig;
export default businessConfig;